import angular from 'angular';
import ngMessages from 'angular-messages';
import moment from 'moment';
import TkrSpaCommon from '../../../common/tkr-spa';
import { TkrPersonService } from '../../../common/tkr-commonservices';
import { IbanService, IbanValidator } from '../../../common/ma-iban';
import { SmartFloat, SmartInteger } from '../../../common/ma-smartfloat-1.0';
import TkrPpCommon from '../../../pp/common/0-pp-common-module';
import TkrPpResources from '../../../pp/prcportal-resource-modules';
import AppHelper from '../../../utils/app-helper';
const subsidy_application_app = angular.module('ng-tkr-app-somero', [
    TkrSpaCommon,
    ngMessages,
    TkrPersonService,
    IbanValidator,
    IbanService,
    SmartFloat,
    SmartInteger,
    TkrPpResources,
    TkrPpCommon,
]);
export default subsidy_application_app.name;
subsidy_application_app.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/err');
        $stateProvider
            .state('err', {
            url: '/err',
            template: '<p class="h4 text-danger">Sisäinen virhe. Ota yhteyttä helpdesk@matriset.fi.</p>'
        })
            .state('root', {
            url: '',
            template: '',
            controller: 'AppRedirCtrl',
            controllerAs: 'vm'
        })
            .state('lomake', {
            url: '/:applicationId',
            template: require('./app.tpl.html'),
            controller: 'SubsidyApplicationController',
            controllerAs: 'vm',
            resolve: {
                app: ['PortalSubsidyAppService', '$stateParams', function (PortalSubsidyAppService, $stateParams) {
                        return PortalSubsidyAppService.get({ appId: $stateParams.applicationId }).$promise;
                    }],
                appPeriod: ['PortalAppPeriodService', 'app', function (PortalAppPeriodService, app) {
                        return PortalAppPeriodService.get({ periodId: app.applicationPeriodId }).$promise;
                    }]
            }
        })
            .state('jatetty', {
            url: '/:applicationId/jatetty',
            template: require('./app-submitted.tpl.html'),
            controller: 'AppSubmittedController',
            controllerAs: 'vm'
        });
    }]);
subsidy_application_app.controller('SubsidyApplicationController', SubsidyApplicationController);
SubsidyApplicationController.$inject = [
    '$scope',
    'app',
    'appPeriod',
    'TkrPersonService',
    '$state',
];
function SubsidyApplicationController($scope, app, appPeriod, TkrPersonService, $state) {
    var vm = this;
    vm.now = moment();
    vm.vuosi = appPeriod.td.wnum.vuosi;
    vm.edvuosi = vm.vuosi - 1;
    vm.loppuAika = moment(appPeriod.end).local().format('D.M.YYYY HH:mm');
    vm.personRoles = TkrPersonService.personRoles;
    vm.chairmanRoles = TkrPersonService.chairmanRoles;
    vm.preprocessApp = function (app) {
        if (!app.chairman) {
            app.chairman = {};
        }
        if (!app.contactPerson) {
            app.contactPerson = {};
        }
        if (!app.td) {
            app.td = {};
        }
        if (!app.td.num) {
            app.td.num = {};
        }
        if (!app.td.bools) {
            app.td.bools = {};
        }
        if (!app.td.text) {
            app.td.text = {};
        }
        if (!app.td.dates) {
            app.td.dates = {};
        }
        if (app.td.num.lapiAjonVrk > 0.00001) {
            app.bypassRoad = true;
        }
        vm.erapaivat = AppHelper.namedPropsToArray(app.td.dates, 'erapaiva');
        if (!vm.erapaivat.length) {
            vm.erapaivat.push('');
        }
    };
    vm.postprocessApp = function (app) {
        if (app.td.bools.isEligible) {
            app.established = true;
            app.td.bools.tilikausiKv = true;
        }
        if (!app.bypassRoad) {
            app.td.num.lapiAjonVrk = 0;
        }
        if (!vm.isSeparateChairmanRequired()) {
            app.chairman = app.contactPerson;
        }
        AppHelper.arrayToNamedProps(vm.erapaivat, 'erapaiva', app.td.dates);
        app.td.text.eraPaivat = '';
        vm.erapaivat.forEach(function (ep) {
            if (app.td.text.eraPaivat) {
                app.td.text.eraPaivat += ', ';
            }
            app.td.text.eraPaivat += moment(ep).format('D.M.YYYY');
        });
    };
    vm.preprocessApp(app);
    vm.app = app;
    $scope.$watch(function () {
        return vm.app.td.dates.yksLaskPvm;
    }, function (newValue, oldValue) {
        vm.yksLaskPvmVirhe = false;
        vm.yksLaskPvmVaroitus = false;
        if (newValue) {
            var laskPvm = moment(newValue, "YYYY-MM-DD");
            if (laskPvm) {
                var ikaKk = vm.now.diff(laskPvm, 'months');
                vm.yksLaskPvmVirhe = (ikaKk > 119);
                vm.yksLaskPvmVaroitus = !vm.yksLaskPvmVirhe && (ikaKk > 83);
            }
        }
    });
    $scope.$watchGroup([
        function () { return vm.yksLaskPvmVirhe; },
        'appForm.yksLaskPvm'
    ], function (newValues, oldValues) {
        if (newValues[1]) {
            newValues[1].$setValidity('vanha', newValues[0] ? false : true);
        }
    });
    vm.isSeparateChairmanRequired = function () {
        return TkrPersonService.isValidChairmanRole(vm.app.contactPerson.role) ? false : true;
    };
    vm.save = function () {
        vm.postprocessApp(vm.app);
        vm.app.applicationState = 'SUBMITTED';
        vm.app.$save().then(function (data) {
            $state.go('jatetty', { applicationId: data.id });
        });
    };
    vm.saveDraft = function () {
        vm.postprocessApp(vm.app);
        vm.app.applicationState = 'DRAFT';
        vm.app.$save().then(function (data) {
            vm.draftSaved = true;
        });
    };
    vm.tyot = [
        {
            id: 'talkooAuraus',
            laji: 'Auraus',
            arvo: 60
        },
        {
            id: 'talkooAurausMerkit',
            laji: 'Aurausmerkkien laitto/poisto',
            ohje: 'Sisältää merkkien kuljetuksen',
            arvo: 8
        },
        {
            id: 'talkooLanaus',
            laji: 'Lanaus ja höyläys',
            ohje: 'Höyläys, tien pinnan muotoilu, reunapalteiden poisto yms.',
            arvo: 75
        },
        {
            id: 'talkooKaivuuHlo',
            laji: 'Kaivuutyöt sekä kuoppien täyttö henkilötyönä',
            arvo: 15
        },
        {
            id: 'talkooKpitoHlo',
            laji: 'Raivaus ja ylläpitotyöt henkilötyönä',
            ohje: 'Kevyet ylläpitotyöt esim. liikennemerkkien pesu.',
            arvo: 10
        },
        {
            id: 'talkooKpitoKone',
            laji: 'Koneellinen kunnossapitotyö',
            ohje: 'Kaikki koneella tehtävät kunnostustyöt esim. ojan kaivuutyöt, koneelliset raivaus- ja niittotyöt, mahdolliset nostotyöt esim. rummun korjaus/vaihtotöissä.',
            arvo: 65
        }
    ];
    vm.tyonArvo = function (tyo, tunnit) {
        var arvo = tyo.arvo * tunnit;
        return Math.round(arvo * 100) / 100 || '';
    };
    vm.tyonArvoTotal = function (tyot, app) {
        var sum = 0;
        tyot.forEach(function (tyo) {
            if (app && app.td.num[tyo.id]) {
                sum += vm.tyonArvo(tyo, app.td.num[tyo.id]);
            }
        });
        return sum;
    };
}
subsidy_application_app.directive('someroEdit', EditorDirective);
EditorDirective.$inject = ['$compile'];
function EditorDirective($compile) {
    var buildTemplate = function (scope, attrs) {
        var inputId = 'fld' + scope.$id;
        var inputLabel = attrs.inputLabel || inputId;
        var htmlInputType = 'text';
        var inputExtra = '';
        var addonOpen = '';
        var addonClose = '';
        var mSize = attrs.mSize || '';
        if (attrs.mType == 'integer') {
            inputExtra += 'smart-integer';
        }
        else if (attrs.mType == 'number') {
            inputExtra += 'smart-float';
        }
        else if (attrs.mType == 'email') {
            htmlInputType = 'email';
        }
        if (scope.inputAddon) {
            addonOpen = '<div class="input-group">';
            addonClose = '<span class="input-group-addon">' + scope.inputAddon + '</span></div>';
        }
        var html = [];
        html.push('<div class="form-group" ng-class="{ \'has-error\' : appForm.INPUTID.$invalid }">');
        html.push('<label for="INPUTID" class="control-label col-sm-4 col-md-3">INPUTLABEL <span ng-if="required">*</span></label>');
        html.push('<div class="col-sm-6">');
        html.push(addonOpen);
        html.push('<input type="' + htmlInputType + '" class="form-control M_SIZE" id="INPUTID" name="INPUTID" placeholder="INPUTLABEL" ng-model="ngModel" ' + inputExtra + ' ng-required="required">');
        html.push(addonClose);
        html.push('<div ng-messages="appForm.INPUTID.$error" role="alert">');
        html.push('<p ng-message="required" class="help-block bg-danger">Pakollinen tieto</p>');
        html.push('<p ng-message="integer" class="help-block bg-danger">Syötä kokonaisluku</p>');
        html.push('<p ng-message="float" class="help-block bg-danger">Syötä desimaaliluku</p>');
        html.push('<p ng-message="email" class="help-block bg-danger">Syötä sähköpostiosoite</p>');
        html.push('</div>');
        if (attrs.mHelp) {
            html.push('<p class="help-block">' + attrs.mHelp + '</p>');
        }
        html.push('</div>');
        html.push('</div>');
        var result = html.join("\n").replace(/INPUTID/g, inputId).replace(/INPUTLABEL/g, inputLabel).replace(/M_SIZE/g, mSize);
        return result;
    };
    var linker = function linker(scope, element, attrs, ctrls) {
        scope.appForm = ctrls[0];
        scope.inputAddon = attrs.inputAddon;
        scope.required = attrs.required === '' ? true : attrs.required;
        element.html(buildTemplate(scope, attrs)).show();
        $compile(element.contents())(scope);
    };
    return {
        restrict: 'E',
        replace: false,
        require: ['^form'],
        scope: {
            ngModel: '=',
            mSize: '='
        },
        link: linker
    };
}
